import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { storeVisitStatisticsApi } from '../../api/storeVisitStatistics';

// 异步Action
export const fetchStoreVisitStatisticsList = createAsyncThunk(
  'storeVisitStatistics/fetchList',
  async (params, { rejectWithValue }) => {
    try {
      const response = await storeVisitStatisticsApi.listStoreVisitStatistics(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || '获取店铺访问统计列表失败');
    }
  }
);

export const fetchStoreVisitStatisticsPage = createAsyncThunk(
  'storeVisitStatistics/fetchPage',
  async (params, { rejectWithValue }) => {
    try {
      const response = await storeVisitStatisticsApi.pageStoreVisitStatistics(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || '分页查询店铺访问统计失败');
    }
  }
);

export const fetchStoreVisitStatisticsDetail = createAsyncThunk(
  'storeVisitStatistics/fetchDetail',
  async (id, { rejectWithValue }) => {
    try {
      const response = await storeVisitStatisticsApi.getStoreVisitStatisticsById(id);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || '获取店铺访问统计详情失败');
    }
  }
);

export const deleteStoreVisitStatistics = createAsyncThunk(
  'storeVisitStatistics/delete',
  async (id, { rejectWithValue }) => {
    try {
      const response = await storeVisitStatisticsApi.deleteStoreVisitStatisticsById(id);
      return { id, ...response.data };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || '删除店铺访问统计失败');
    }
  }
);

export const countStoreVisitStatisticsByStatus = createAsyncThunk(
  'storeVisitStatistics/countByStatus',
  async (status, { rejectWithValue }) => {
    try {
      const response = await storeVisitStatisticsApi.countStoreVisitStatisticsByStatus(status);
      return { status, count: response.data };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || '统计店铺访问统计数量失败');
    }
  }
);

// 初始状态
const initialState = {
  statisticsList: [],
  statisticsDetail: null,
  statisticsPagination: {
    current: 1,
    pageSize: 10,
    total: 0
  },
  statusCount: {},
  loading: false,
  detailLoading: false,
  error: null
};

// 创建Slice
const storeVisitStatisticsSlice = createSlice({
  name: 'storeVisitStatistics',
  initialState,
  reducers: {
    setStatisticsPagination: (state, action) => {
      state.statisticsPagination = { ...state.statisticsPagination, ...action.payload };
    },
    clearStatisticsDetail: (state) => {
      state.statisticsDetail = null;
    },
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // 获取店铺访问统计列表
      .addCase(fetchStoreVisitStatisticsList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStoreVisitStatisticsList.fulfilled, (state, action) => {
        state.loading = false;
        state.statisticsList = action.payload || [];
      })
      .addCase(fetchStoreVisitStatisticsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || '获取店铺访问统计列表失败';
      })
      // 分页查询店铺访问统计
      .addCase(fetchStoreVisitStatisticsPage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStoreVisitStatisticsPage.fulfilled, (state, action) => {
        state.loading = false;
        state.statisticsList = action.payload.records || [];
        state.statisticsPagination.total = action.payload.total || 0;
      })
      .addCase(fetchStoreVisitStatisticsPage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || '分页查询店铺访问统计失败';
      })
      // 获取店铺访问统计详情
      .addCase(fetchStoreVisitStatisticsDetail.pending, (state) => {
        state.detailLoading = true;
        state.error = null;
      })
      .addCase(fetchStoreVisitStatisticsDetail.fulfilled, (state, action) => {
        state.detailLoading = false;
        state.statisticsDetail = action.payload;
      })
      .addCase(fetchStoreVisitStatisticsDetail.rejected, (state, action) => {
        state.detailLoading = false;
        state.error = action.payload || '获取店铺访问统计详情失败';
      })
      // 删除店铺访问统计
      .addCase(deleteStoreVisitStatistics.fulfilled, (state, action) => {
        state.statisticsList = state.statisticsList.filter(item => item.id !== action.payload.id);
        state.statisticsPagination.total -= 1;
        if (state.statisticsDetail && state.statisticsDetail.id === action.payload.id) {
          state.statisticsDetail = null;
        }
      })
      // 统计店铺访问统计数量
      .addCase(countStoreVisitStatisticsByStatus.fulfilled, (state, action) => {
        state.statusCount[action.payload.status] = action.payload.count;
      });
  }
});

export const { setStatisticsPagination, clearStatisticsDetail, clearError } = storeVisitStatisticsSlice.actions;
export default storeVisitStatisticsSlice.reducer;
